import { graphql, useStaticQuery } from "gatsby";

import getInternalLinkById from "../../utils/getInternalLinkById";
import getSitePages from "../../utils/getSitePages";

const getSidebarNavigationNode = (id, graphqlData = null) => {
  let data = graphqlData;

  if (!data) {
    data = useStaticQuery(graphql`
     {
      primaryNavigation: allKontentItemNavigationItem(filter: {system: {codename: {eq: "primary_navigation"}}}) {
        nodes {
          id
          elements {
            elements {
              value {
                id
                preferred_language
                ... on kontent_item_navigation_item {
                  id,
                  elements {
                    title {
                      value
                    }
                    url_slug {
                      value
                    }
                    external_url {
                      value
                    }
                    elements {
                      value {
                        ... on kontent_item_navigation_item {
                          id
                          elements {
                            title {
                              value
                            }
                            url_slug {
                              value
                            }
                            external_url {
                              value
                            }
                            elements {
                              value {
                                ... on kontent_item_navigation_item {
                                  id
                                  elements {
                                    title {
                                      value
                                    }
                                    url_slug {
                                      value
                                    }
                                    external_url {
                                      value
                                    }
                                    elements {
                                      value {
                                        ... on kontent_item_navigation_item {
                                          id
                                          elements {
                                            title {
                                              value
                                            }
                                            url_slug {
                                              value
                                            }
                                            external_url {
                                              value
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  }

  const { links } = getSitePages();

  if (id) {
    const node = getInternalLinkById(id);

    if (node) {
      const slugParts = node.slug.split("/");
      // Remove first empty element
      slugParts.shift();

      if (slugParts.length > 0 && slugParts[0]) {
        const navigationData = data.primaryNavigation.nodes[0].elements.elements.value;

        const mainItem = links.nodes.find((el) => el.slug === `/${slugParts[0]}/${slugParts[1]}`);

        if (mainItem) {
          let mainNavigation;
          navigationData.forEach((o) => o.elements?.elements?.value.some((el) => {
            if (el.id === mainItem.nodeId || el.id === mainItem.parentId) {
              mainNavigation = o;

              return true;
            }

            return false;
          }));

          if (!mainNavigation) return null;

          const sidebarLevel = mainNavigation.elements.elements.value.find(
            (el) => el.id === mainItem.nodeId || el.id === mainItem.parentId,
          );

          if (sidebarLevel) {
            return { navId: node.id, sidebarLevel };
          }
        }
      }
    }
  }

  return null;
};

export {
  // eslint-disable-next-line import/prefer-default-export
  getSidebarNavigationNode,
};
